import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"
import { toggleFacets, lumberFinishFilters } from "../config"

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters()

    return (
        filters.length > 0 && (
            <div class="flex overflow-hidden mb-sm">
                <div class="relative overflow-auto scroll-area flex items-center w-full pl-pagemargin py-0 gap-xs lg:flex-wrap [&amp;:not(:empty)]:mt-sm lg:[&amp;:not(:empty)]:mt-0">
                    <button
                        type="button"
                        aria-label="Clear all filters"
                        class="body-14 underline text-t-foreground whitespace-nowrap shrink-0"
                        onClick={removeAll}
                    >
                        Clear Filters
                    </button>
                    {filters.map(filter => {
                        const isLumberFinish = filter.name === "Lumber Finish";
                        const isToggle = toggleFacets.find(f => f.facetName.toLowerCase() === filter.name.toLowerCase());
                        const valueName = isToggle
                            ? filter.name 
                            : isLumberFinish 
                                ? lumberFinishFilters[filter.value] 
                                : filter.value;

                        return (
                            <button
                                key={`${filter.name}: ${filter.value}`}
                                type="button"
                                aria-label={`Remove filter: ${valueName}`}
                                onClick={() => filter.remove()}
                                class="ns-selected-filter flex justify-center p-xs bg-t-background-secondary text-t-foreground whitespace-nowrap shrink-0"
                            >
                                <span class="capitalize inline-flex gap-xs items-center caption">
                                    {valueName}
                                    <svg class="block w-full h-full" aria-label="icon-close" role="presentation" focusable="false">
                                        <use crossorigin="anonymous" href="//www.polywood.com/cdn/shop/t/269/assets/icons.svg?v=2323025294473912441739904367#icon-close"></use>
                                    </svg>
                                </span>
                            </button>
                        )
                    })}
                </div>
            </div>
        )
    )
}
